import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDBodyText, FDHeadlineText, FDPaper, FDStack,
} from '@facet-wealth/design';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MemberResponse
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Components/MoneyMindsetSubSection/MemberResponse';

const MoneyMindsetSubSection = ({
  resource,
}) => {
  const theme = useTheme();
  const title = resource.attr('title');
  const selectedOptions = resource.attr('selectedOptions') ?? [];
  const memberResponses = resource.attr('memberResponses')?.resources()?.list() ?? [];
  return (
    <FDStack direction={'column'} spacing={1}>
      {title ? <FDHeadlineText size={'sm'} value={title} color={'textSecondary'} /> : null}
      {selectedOptions ? (
        <FDStack direction={'row'} spacing={1} wrap>
          {resource.attr('selectedOptions')?.map((selectedOption) => {
            return (
              <FDPaper appearance={'flat'} color={'info'} padding={2}>
                <FDBodyText size={'lg'} value={selectedOption} />
              </FDPaper>
            );
          })}
        </FDStack>
      ) : null}
      {memberResponses ? (
        <Box
          display="grid"
          gridTemplateColumns={`repeat(auto-fill, calc(50% - ${theme.spacing(1)}px))`}
          gridGap={theme.spacing(2)}
        >
          {
            (resource.attr('memberResponses')?.resources()?.list() ?? []).map((memberResponseResource) => {
              return <MemberResponse resource={memberResponseResource} />;
            })
          }
        </Box>
      ) : null}
    </FDStack>
  );
};

MoneyMindsetSubSection.defaultProps = {
};

MoneyMindsetSubSection.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default MoneyMindsetSubSection;
